class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.form = this.querySelector('form');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.predictiveSearchResults.addEventListener('touchmove', () => {
      if (window.matchMedia('(max-width: 749px)').matches) {
        this.input.blur();
      }
    }, { passive: true });

    if (this.form) {
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();

        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
          this.close();
          return;
        }

        this.getSearchResults(searchTerm);

        if (window.matchMedia('(max-width: 749px)').matches) {
          this.input.blur();
        }
      });
    }
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const originalSearchTerm = this.getWildcardSearchTerm(searchTerm);
    const fallbackSearchTerm = this.getSmartSearchTerm(searchTerm);

    this.fetchSearchResults(originalSearchTerm)
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const hasProducts = html.querySelector('.predictive-search-product-card');

        if (!hasProducts && fallbackSearchTerm !== searchTerm.trim()) {
          return this.fetchSearchResults(fallbackSearchTerm);
        }

        return text;
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;

        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  fetchSearchResults(term) {
    return fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(term)}&section_id=predictive-search&resources[options][fields]=title,body,product_type,variants.title,vendor,tag&resources[type]=product`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      });
  }

  getWildcardSearchTerm(searchTerm) {
    const cleanTerm = searchTerm.trim();

    if (cleanTerm.length >= 4 && !cleanTerm.includes(' ')) {
      return `${cleanTerm}*`;
    }

    return cleanTerm;
  }

  getSmartSearchTerm(searchTerm) {
    const normalize = (value) =>
      String(value || '')
        .toLowerCase()
        .trim()
        .replace(/[æ]/g, 'ae')
        .replace(/[ø]/g, 'o')
        .replace(/[å]/g, 'a')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ');

    const normalized = normalize(searchTerm);

    if (normalized.startsWith('til ')) {
      return searchTerm.trim();
    }

    const fallbackMap = {
      pappa: 'til far',
      fader: 'til far',
      paps: 'til far',
      far: 'til far',

      mamma: 'til mor',
      mams: 'til mor',
      mor: 'til mor',

      soster: 'til søster',
      soester: 'til søster',
      bror: 'til bror',

      sonn: 'til sønn',
      soenn: 'til sønn',
      datter: 'til datter',

      kjaereste: 'til kjæreste',
      kjaerste: 'til kjæreste',
      kjareste: 'til kjæreste',

      ektemann: 'til mann',
      hustru: 'til kone',

      laerer: 'til lærer',
      larer: 'til lærer',

      bursda: 'bursdag',
      brusdag: 'bursdag',
      bursdaggave: 'bursdag',
      bursdagsgave: 'bursdag',

      gratulasjon: 'gratulerer',
      gratulere: 'gratulerer',
      grattis: 'gratulerer',

      godbedring: 'god bedring',
      godbedringgave: 'god bedring',
      godbedringsgave: 'god bedring',

      heier: 'heier på deg',
      tenker: 'tenker på deg',
      villebaresi: 'ville bare si',
      barefordi: 'bare fordi'
    };

    if (fallbackMap[normalized]) {
      return fallbackMap[normalized];
    }

    return searchTerm.trim();
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);